/* eslint-disable global-require */
import Router from '@/router';
import { findNotificacoes, updateNotificacao } from '@/services/notificacao';

const dashGetters = {
  drawer(state) {
    return state.drawer;
  },
  account(st, gt, rSt) {
    return rSt.auth.account;
  },
  hasPermission(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name !== 'pesquisador') {
      return true;
    }
    return false;
  },
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  logo() {
    return require('@/assets/logo-small.png');
  },
  breadcrumbs(st, gt, rSt) {
    const breadcrumbs = rSt.route.path.split('/');
    return breadcrumbs[1];
    // return breadcrumbs.reduce((arr, breadcrumb) => {
    //   if (breadcrumb) {
    //     arr.push({
    //       text: (breadcrumb.charAt(0).toUpperCase() + breadcrumb.slice(1)).replace(/-/g, ' '),
    //     });
    //   }
    //   return arr;
    // }, []);
  },
  menu() {
    return [
      {
        title: 'Acervo',
        icon: 'fas fa-search',
        to: { name: 'Acervo listar' },
      },
      {
        title: 'Relatórios',
        icon: 'fas fa-chart-bar',
        to: { name: 'Relatórios' },
        requires: ['admin', 'operador'],
      },
      {
        title: 'Usuários',
        icon: 'fas fa-users',
        to: { name: 'Usuários' },
        requires: ['admin'],
      },
    ];
  },
  notifications(st) {
    return st.notifications.sort((a, b) => a.lida - b.lida);
  },
};
const mutations = {
  openDrawer(state) {
    state.drawer = true;
  },
  closeDrawer(state) {
    state.drawer = false;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
  },
  addNotifications(state, notifications) {
    state.notifications.push(...notifications);
  },
  setTotal(state, total) {
    state.total = total;
  },
  addPage(state) {
    state.page += 1;
  },
  setPage(state, page) {
    state.page = page;
  },
  setCanLoad(state, value) {
    state.canLoad = value;
  },
};
const actions = {
  onDrawerChange({ commit, getters }, drawer) {
    // avoid infinite loops
    if (drawer === getters.drawer) return;

    if (drawer) {
      commit('openDrawer');
    } else {
      commit('closeDrawer');
    }
  },
  onDrawerToggle({ commit, getters }) {
    if (getters.drawer) {
      commit('closeDrawer');
    } else {
      commit('openDrawer');
    }
  },
  onMenuClick(_, to) {
    Router.push(to);
  },
  onSignOut({ dispatch, commit }, _) {
    commit('setNotifications', []);
    commit('setCanLoad', true);
    commit('setPage', 0);
    commit('setTotal', 0);
    dispatch('views/collection/list/onSearchTypeChange', 'simple', { root: true });
    commit('views/collection/list/setItems', [], { root: true });
    dispatch('auth/signOut', _, { root: true });
  },
  afterRouteUpdate({ dispatch, getters }) {
    if (getters.hasPermission) {
      dispatch('findNotificacoes');
    }
  },
  findNotificacoes({ commit, getters, state }, $event) {
    if (state.canLoad) {
      const { id } = getters.account;
      let filter = {
        where: {
          idOperador: id,
          tipo: 'recusado',
        },
      };
      if (getters.isAdmin) {
        filter = {
          where: { tipo: 'avaliar' },
        };
      }
      filter.include = ['admin', { publicacao: 'suporteBase' }];
      filter.order = 'id DESC';
      filter.limit = 10;
      filter.skip = 10 * state.page;
      findNotificacoes(filter)
        .then(({ items, total }) => {
          commit('setTotal', total);
          commit('addNotifications', items);
          if (state.notifications.length < state.total) {
            commit('addPage');
            if ($event) {
              $event.loaded();
            }
          } else {
            commit('setCanLoad', false);
            if ($event) {
              $event.complete();
            }
          }
        });
    }
  },
  readAndGo({ dispatch }, not) {
    not.lida = true;
    updateNotificacao(not)
      .then(() => {
        dispatch('afterRouteUpdate');
        Router.push({ name: 'Acervo ver', params: { id: not.publicacao.id } });
      });
  },
  onLogoClick({ dispatch, rootState }) {
    if (rootState.route && rootState.route.name !== 'Acervo listar') {
      Router.push({ name: 'Acervo listar' });
    }
    dispatch('views/collection/list/onSearchTypeChange', 'simple', { root: true });
  },
};

export default {
  namespaced: true,
  state: {
    drawer: true,
    notifications: [],
    page: 0,
    total: 0,
    canLoad: true,
  },
  mutations,
  getters: dashGetters,
  actions,
};
